export class dashboardData {
  static readonly type = '[dashboard] Load dashboard data';
}
